import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import PageLoader from '../../components/PageLoader/PageLoader'
import Paginate from '../../components/pagination/paginate'
import Select from 'react-select'
import { appGetAllSanstha } from '../../store/sanstha'
import { appAllGetHubs } from '../../store/hubs'
import PostPreview from '../../components/PostPreview/PostPreview'
import {
	appDeleteEvent,
	appGetAllEvent,
	appGetEventDetails,
	appGetUserParticipantsEventDetails,
	setEmptyEvent,
} from '../../store/event'
import { toCamelCase } from '../../utils/Function'

function TableFilter({ setExportFilters }) {
	const dispatch = useDispatch()
	const params = useParams()
	const navigate = useNavigate()
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	const event = useSelector(state => state?.eventReducer.event)
	const isloder = useSelector(state => state?.eventReducer.isloder)
	const paginate = useSelector(state => state.eventReducer.paginate)
	const isdeleted = useSelector(state => state?.eventReducer?.isdeleted)

	const eventDetails = useSelector(state => state.eventReducer.eventDetails)

	const eventParticipantUserDetails = useSelector(
		state => state.eventReducer.eventParticipantUserDetails,
	)
	//	console.log(eventParticipantUserDetails)
	const participants = Array.isArray(eventParticipantUserDetails) ? eventParticipantUserDetails : []

	const [page, setPage] = useState(params.page || 1)
	const [selectedFilters, setSelectedFilters] = useState({
		hub: null,
		sanstha: null,
		categoryOptions: null,
		status: '',
	})
	const [activeFilters, setActiveFilters] = useState({})
	const [showEventDetailsModal, setShowEventDetailsModal] = useState(false)

	const categoryOptions = [
		{ value: 'Cultural', label: 'Cultural' },
		{ value: 'Religious', label: 'Religious' },
		{ value: 'Wedding', label: 'Wedding' },
		{ value: 'General Meeting', label: 'General Meeting' },
		{ value: 'Medical Camp', label: 'Medical Camp' },
		{ value: 'Workshop', label: 'Workshop' },
		{ value: 'Sports', label: 'Sports' },
		{ value: 'Talent Show', label: 'Talent Show' },
		{ value: 'Donation Drive', label: 'Donation Drive' },
		{ value: 'Matrimonial Meet', label: 'Matrimonial Meet' },
		{ value: 'Family Gathering', label: 'Family Gathering' },
		{ value: 'Felicitation', label: 'Felicitation' },
		{ value: 'Blood Donation Camp', label: 'Blood Donation Camp' },
		{ value: 'Free Eye Checkup', label: 'Free Eye Checkup' },
		{ value: 'Housewarming', label: 'Housewarming' },
		{ value: 'Anniversary', label: 'Anniversary' },
		{ value: 'Personal Puja', label: 'Personal Puja' },
	]

	const handleDeleteEvent = id => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this Event?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(appDeleteEvent(id)).then(() => {
					dispatch(
						appGetAllEvent({ page: 1, limit: 10, sanstha: sansthaId || permissionOfSanstha }),
					)
				})
			}
		})
	}

	useEffect(() => {
		const params = {
			page,
			limit: 10,
			sanstha: sansthaId || permissionOfSanstha,
			...activeFilters,
		}

		dispatch(appGetAllEvent(params))
		navigate(`/event/${page}`)
	}, [page, activeFilters, isdeleted])

	const handleSearch = useCallback(() => {
		const filters = {}
		if (selectedFilters.hub) {
			filters.hub = selectedFilters.hub.value
		}
		if (selectedFilters.sanstha) {
			filters.sanstha = selectedFilters.sanstha.value
		}
		if (selectedFilters.categoryOptions) {
			filters.categoryOptions = selectedFilters.categoryOptions.value
		}
		if (selectedFilters.status) {
			filters.status = selectedFilters.status
		}
		setActiveFilters(filters)
		setExportFilters(filters)
		setPage(1)
	}, [selectedFilters])

	const handleShowEventDetails = eventId => {
		//console.log(eventId)
		dispatch(appGetEventDetails(eventId))
		dispatch(
			appGetUserParticipantsEventDetails({
				event: eventId,
				// status: "Accepted",
			}),
		)
		// setSelectedEventDetails(eventDetails);
		setShowEventDetailsModal(true)
	}

	const handleCloseEventDetails = () => {
		setShowEventDetailsModal(false)
		dispatch(setEmptyEvent())
	}

	const getCreatorName = value => {
		if (value?.userId) {
			return (
				<div className="d-flex flex-column align-items-center">
					<PostPreview value={value?.userId?.profilePic || '/img/user.jpg'} />

					<span className="fw-semibold mt-1">
						{value?.userId?.firstName} {value?.userId?.lastName}
					</span>

					<small className="text-muted">{value?.userId?.mobile}</small>
				</div>
			)
		}

		if (value?.superAdmin) {
			return (
				<div className="d-flex flex-column align-items-center">
					<span className="badge badge-success mt-1">Super Admin</span>
				</div>
			)
		}

		if (value?.hubAdmin) {
			return (
				<div className="d-flex flex-column align-items-center">
					<PostPreview value={value?.hub?.admin?.profilePic || '/img/user.jpg'} />

					<small className="fw-semibold mt-1 mb-0 d-block lh-sm">
						{value?.hub?.admin?.firstName} {value?.hub?.admin?.lastName}
					</small>

					<small className="text-muted d-block lh-sm">{value?.hub?.admin?.mobile}</small>

					<span className="badge badge-primary mt-1">Community Admin</span>
				</div>
			)
		}

		if (value?.sansthAdmin || value?.sansthaAdmin) {
			return (
				<div className="d-flex flex-column align-items-center">
					<PostPreview value={value?.sanstha?.admin?.profilePic || '/img/user.jpg'} />

					<small className="fw-semibold mt-1 mb-0 d-block lh-sm">
						{value?.sanstha?.admin?.firstName} {value?.sanstha?.admin?.lastName}
					</small>

					<small className="text-muted d-block lh-sm">{value?.sanstha?.admin?.mobile}</small>

					<span className="badge badge-primary">Sanstha Admin</span>
				</div>
			)
		}

		return (
			<div className="d-flex flex-column align-items-center">
				<span className="badge badge-success mt-1">Super Admin</span>
			</div>
		)
	}

	return (
		<>
			{/* {isloder && <PageLoader />} */}
			<div className="card dataTables_wrapper">
				<div className="card-body">
					<div className="row">
						<div className="col-md-2">
							<label>Category </label>
							<Select
								name="category"
								options={categoryOptions}
								onChange={option => {
									setSelectedFilters(prev => ({
										...prev,
										categoryOptions: option,
									}))
								}}
								value={selectedFilters.categoryOptions}
								placeholder="Select category..."
							/>
						</div>
						<div className="col-md-2">
							<div className="form-group">
								<label>Status</label>
								<select
									className="form-control"
									name="status"
									value={selectedFilters.status}
									onChange={e => {
										setSelectedFilters(prev => ({
											...prev,
											status: e.target.value,
										}))
									}}
								>
									<option value="">Select status</option>
									<option value="Upcoming">Upcoming</option>
									<option value="Active">Active</option>
									<option value="Completed">Completed</option>
								</select>
							</div>
						</div>

						<div className="d-flex" style={{ alignItems: 'center', marginTop: '12px' }}>
							<button
								className="btn btn-primary mr-2"
								onClick={handleSearch}
								style={{ marginRight: '8px' }}
							>
								<em className="fas fa-search"></em> Search
							</button>
							<button
								className="btn btn-secondary"
								onClick={() => {
									setSelectedFilters({
										hub: null,
										sanstha: null,
										categoryOptions: null,
										status: '',
									})
									setPage(1)
									setActiveFilters({})
									setExportFilters({})
								}}
							>
								<em className="fas fa-redo"></em> Reset
							</button>
						</div>
					</div>

					<div className="table-responsive bootgrid">
						<table className="table table-hover" id="bootgrid-command">
							<thead>
								<tr>
									<th>Community</th>
									<th>Sanstha</th>
									{/* <th>Event</th> */}
									<th>Event</th>
									{/* <th>Description </th> */}
									<th>Category </th>
									<th>Status</th>
									<th>Recived Amount (Rs)</th>
									{/* <th>Location </th> */}
									<th>Start Date</th>
									<th>End Date</th>
									<th>Posted by</th>
									<th data-column-id="commands" data-formatter="commands" data-sortable="false">
										<div></div>
									</th>
								</tr>
							</thead>
							{event.data &&
								event.data.map((value, index) => {
									return (
										<tbody key={index}>
											<tr>
												<td
													style={{
														maxWidth: '150px',
														wordWrap: 'break-word',
														whiteSpace: 'normal',
														textTransform: 'capitalize',
													}}
												>
													{value?.hub ? (
														<>
															{value.hub.image && (
																<PostPreview value={value.hub.image} />
																// <img
																//   src={value.hub.image}
																//   alt="community"
																//   style={{
																//     width: "50px",
																//     height: "50px",
																//     borderRadius: "50%",
																//     objectFit: "cover",
																//   }}
																// />
															)}
															{/* <br /> */}
															{toCamelCase(value?.hub?.name) || '—'}
														</>
													) : (
														''
													)}
												</td>
												<td
													style={{
														maxWidth: '150px',
														wordWrap: 'break-word',
														whiteSpace: 'normal',
														textTransform: 'capitalize',
													}}
												>
													{value?.sanstha ? (
														<>
															{value.sanstha.image && (
																<PostPreview value={value.sanstha.image} />

																// <img
																//   src={value.sanstha.image}
																//   alt="sanstha"
																//   style={{
																//     width: "50px",
																//     height: "50px",
																//     borderRadius: "50%",
																//     objectFit: "cover",
																//   }}
																// />
															)}
															{/* <br /> */}
															{toCamelCase(value?.sanstha?.name) || '—'}
														</>
													) : (
														''
													)}
												</td>
												<td>
													<PostPreview value={value} />
													{/* <img
                            src={value?.file}
                            alt="event"
                            style={{
                              width: "50px",
                              height: "50px",
                              borderRadius: "50%",
                            }}
                          />
                          <br /> */}
													<span
														style={{
															maxWidth: '150px',
															wordWrap: 'break-word',
															whiteSpace: 'normal',
															textTransform: 'capitalize',
														}}
													>
														{value.title}
													</span>
												</td>
												{/* <td
                          style={{
                            maxWidth: "150px",
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                            textTransform: "capitalize",
                          }}
                        >
                          {value?.title}
                        </td> */}
												{/* <td>{value.description}</td> */}
												<td>{toCamelCase(value?.category)}</td>

												{/* <td>
                          {event.data.locationType == "Physical" ? (
                            <>
                              {value?.nativePlaceAddress && value?.nativeArea && (
                                <>
                                  {value.nativePlaceAddress}, {value.nativeArea}
                                </>
                              )}
                              <br />
                              {value?.nativeBlock &&
                                value?.nativeDistrict &&
                                value?.nativeState &&
                                value?.nativePlacePincode && (
                                  <>
                                    <span>
                                      {value.nativeBlock},{" "}
                                      {value.nativeDistrict},{" "}
                                      {value.nativeState}{" "}
                                      {value.nativePlacePincode}
                                    </span>
                                  </>
                                )}
                            </>
                          ) : (
                            <>{value?.virtualLink}</>
                          )}
                        </td> */}
												<td>
													{' '}
													<span
														className={`badge ${
															value?.status === 'Upcoming'
																? 'badge-warning  '
																: value?.status === 'Active'
																? 'badge-success'
																: value?.status === 'Completed'
																? 'badge-danger'
																: 'badge-light'
														}`}
													>
														{value?.status || 'N/A'}
													</span>
												</td>

												<td style={{ textAlign: 'center' }}>{value?.receivedAmount || 0}</td>
												<td>
													{new Date(value.startDate).toLocaleDateString('en-US', {
														year: 'numeric',
														month: 'short',
														day: 'numeric',
													})}
												</td>
												<td>
													{new Date(value.endDate).toLocaleDateString('en-US', {
														year: 'numeric',
														month: 'short',
														day: 'numeric',
													})}
												</td>
												<td
													style={{
														maxWidth: '150px',
														wordWrap: 'break-word',
														whiteSpace: 'normal',
													}}
												>
													{/* {value?.userId && (
														<div className="flex flex-col items-start">
															<PostPreview value={value?.userId?.profilePic || '/img/user.jpg'} />
															<span>
																{value?.userId?.firstName} {value?.userId?.lastName}
															</span>
															<br />
															<span className="text-sm text-gray-600">{value?.userId?.mobile}</span>
														</div>
													)} */}

													{getCreatorName(value)}
												</td>

												{/* <td className="text-center align-middle">
                          {value?.userId ? (
                            <>
                              {value?.userId && (
                                <img
                                  src={value.userId.profilePic}
                                  alt="user"
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                />
                              )}
                              <br />
                              {value.userId.firstName} {value.userId.lastName}
                            </>
                          ) : (
                            <span> Admin</span>
                          )}
                        </td> */}

												<td>
													<button
														type="button"
														className="btn btn-sm btn-info mr-2 command-edit"
														data-row-id="10253"
														onClick={() => navigate(`/event/edit/${value?._id}`)}
													>
														<em className="fa fa-edit fa-fw"></em>
													</button>
													<button
														onClick={e => {
															e.preventDefault()
															e.stopPropagation()
															handleShowEventDetails(value?._id)
														}}
														className="btn btn-sm btn-primary mr-2"
														title="Details"
													>
														<em className="fa fa-eye fa-fw"></em>
													</button>
													<button
														type="button"
														className="btn btn-sm btn-danger command-delete"
														data-row-id="10253"
														onClick={() => handleDeleteEvent(value?._id)}
													>
														<em className="fa fa-trash fa-fw"></em>
													</button>
												</td>
											</tr>
										</tbody>
									)
								})}
						</table>
					</div>
					{paginate && <Paginate paginate={paginate} page={page} setPage={setPage} />}
				</div>
			</div>

			{showEventDetailsModal && eventDetails && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog modal-lg">
						<div className="modal-content">
							<div className="modal-header">
								<h5>Event Details</h5>
								<button type="button" className="close" onClick={handleCloseEventDetails}>
									x
								</button>
							</div>

							<div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
								<div className="text-center mb-3">
									{eventDetails.file ? (
										eventDetails.file.endsWith('.mp4') ? (
											<video
												controls
												style={{
													width: '70%',
													maxHeight: '200px',
													borderRadius: '10px',
												}}
												src={eventDetails.file}
											/>
										) : (
											<img
												src={eventDetails.file}
												alt="Event"
												style={{
													width: '100%',
													maxHeight: '200px',
													borderRadius: '10px',
													objectFit: 'contain',
												}}
											/>
										)
									) : (
										<p className="text-muted">No event file uploaded</p>
									)}
									<h1 className="modal-title">{eventDetails.title}</h1>
									<p className="text-gray-600">
										<strong>Start:</strong> {new Date(eventDetails.startDate).toLocaleDateString()}{' '}
										| <strong>End:</strong> {new Date(eventDetails.endDate).toLocaleDateString()}
									</p>
									<div
										className=" p-2 mt-1"
										dangerouslySetInnerHTML={{
											__html: eventDetails.description,
										}}
									/>
								</div>

								<div className="row mb-4">
									<div className="col-md-6">
										<h6 className="font-semibold">Community:</h6>
										{eventDetails.hub ? (
											<div className="d-flex align-items-center mt-2">
												<PostPreview value={eventDetails.hub.image} />
												<span className="text-gray-800 ml-2">{eventDetails.hub.name}</span>
											</div>
										) : (
											<p className="text-muted">N/A</p>
										)}
									</div>

									<div className="col-md-6">
										<h6 className="font-semibold">Sanstha:</h6>
										{eventDetails.sanstha ? (
											<div className="d-flex align-items-center mt-2">
												<PostPreview value={eventDetails.sanstha.image} />
												<span className="text-gray-800 ml-2">{eventDetails.sanstha.name}</span>
											</div>
										) : (
											<p className="text-muted">N/A</p>
										)}
									</div>
								</div>

								<div className="row mb-3">
									<div className="col-md-6">
										<strong>{eventDetails.category} Event</strong>
									</div>
									<div className="col-md-6 mb-4">
										<h6 className="font-semibold">Location:</h6>
										{eventDetails.locationType === 'Physical' ? (
											<p className="mt-2 text-gray-700">
												{eventDetails.nativePlaceAddress}, {eventDetails.nativeArea},{' '}
												{eventDetails.nativeDistrict}, {eventDetails.nativeState} -{' '}
												{eventDetails.nativePlacePincode}
											</p>
										) : (
											<a
												href={eventDetails.virtualLink}
												target="_blank"
												rel="noopener noreferrer"
												className="text-primary underline"
											>
												{eventDetails.virtualLink}
											</a>
										)}
									</div>
								</div>

								{eventDetails.payment_mode_enabled && (
									<div className="mb-3">
										<strong>UPI ID:</strong> {eventDetails.upi_id}
									</div>
								)}

								<div className="row mb-3">
									<div className="col-md-6">
										<p>
											<strong>RSVP Enabled:</strong> {eventDetails.RSVP_Enabled ? 'Yes' : 'No'}
										</p>
										<p>
											<strong>RSVP:</strong> {eventDetails.RSVP_limit}
										</p>
										<p>
											<strong>RSVP Deadline:</strong>{' '}
											{eventDetails.RSVP_deadline
												? new Date(eventDetails.RSVP_deadline).toLocaleDateString('en-US', {
														year: 'numeric',
														month: 'short',
														day: 'numeric',
												  })
												: 'N/A'}
										</p>
									</div>
									<div className="col-md-6">
										{eventDetails.Allow_Vlonteers && (
											<p>
												<strong>Volunteers Accepted:</strong>{' '}
												{eventDetails.Allow_Vlonteers ? 'Yes' : 'No'}
											</p>
										)}
										<p>
											<strong>Waitlist Enabled:</strong>{' '}
											{eventDetails.Waitlist_Enabled ? 'Yes' : 'No'}
										</p>
									</div>
								</div>

								<div className="row g-3">
									{/* Boli Items Table */}
									{eventDetails.boli_items?.length > 0 && (
										<div className="col-md-6">
											<div className=" p-3 bg-white">
												<h5 className="font-semibold text-primary mb-3">Boli Items</h5>
												{eventDetails.boli_items.map((item, index) => (
													<div key={index} className="mb-3 border rounded-lg p-2">
														<h6 className="font-semibold text-gray-700 mb-2">{item.item_name}</h6>
														<table className="table table-sm table-bordered mb-0">
															<thead className="table">
																<tr>
																	<th>User</th>
																	<th>Amount</th>
																	<th>Status</th>
																	<th>Date</th>
																</tr>
															</thead>
															<tbody>
																{item.sponsored_by?.map((sponsor, i) => (
																	<tr key={i}>
																		<td>
																			<PostPreview
																				value={sponsor.userId?.profilePic || '/img/user.jpg'}
																			/>
																			{sponsor.userId?.firstName} {sponsor.userId?.lastName}
																			<br />
																			{sponsor.userId.mobile}
																		</td>
																		<td>{sponsor.amount}</td>
																		<td>
																			<span
																				className={`badge ${
																					sponsor?.status === 'Pending'
																						? 'badge-warning'
																						: sponsor?.status === 'Paid'
																						? 'badge-success'
																						: 'badge-light'
																				}`}
																			>
																				{sponsor?.status || 'N/A'}
																			</span>
																		</td>

																		<td>
																			{sponsor?.date
																				? new Date(sponsor.date).toLocaleDateString('en-US', {
																						year: 'numeric',
																						month: 'short',
																						day: 'numeric',
																				  })
																				: null}
																		</td>
																	</tr>
																))}
															</tbody>
														</table>
													</div>
												))}
											</div>
										</div>
									)}

									{/* Volunteers Table */}
									{eventDetails.volunteers?.length > 0 && (
										<div className="col-md-6">
											<div className="p-3 bg-white">
												<h5 className="font-semibold text-primary mb-3">Volunteers</h5>

												{eventDetails.volunteers.map((vol, index) => (
													<div
														key={index}
														className="mb-3 p-2 border rounded-md overflow-hidden shadow-sm"
													>
														{/* Role name with border */}
														<div className="border border-gray-300 rounded-md px-3 py-2 bg-gray-50 mb-2">
															<h6 className="font-semibold text-gray-700 m-0">{vol.role}</h6>
														</div>

														<table className="table table-sm table-bordered mb-0 align-middle">
															<thead className="table">
																<tr>
																	<th className="text-center">User</th>
																	<th className="text-center">Required</th>
																</tr>
															</thead>
															<tbody>
																<tr>
																	<td>
																		<div className="d-flex flex-wrap gap-3 justify-content-start">
																			{vol.userId?.map((user, uIndex) => (
																				<div key={uIndex} className="text-center p-2">
																					<PostPreview value={user.profilePic || '/img/user.jpg'} />
																					<div className="text-sm">
																						{user.firstName} {user.lastName}
																					</div>
																					<div className="text-xs text-muted">{user.mobile}</div>
																				</div>
																			))}
																		</div>
																	</td>
																	<td className="text-center align-middle">
																		{vol.remaining_count}
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												))}
											</div>
										</div>
									)}
								</div>

								{/* {eventDetails.volunteers?.length > 0 && (
                  <div className="mb-3">
                    <strong>Volunteers:</strong>
                    <ul className="mt-1">
                      {eventDetails.volunteers.map((vol, volIndex) => (
                        <li key={vol._id || volIndex} className="mb-3">
                          <p className="font-semibold">
                            Role: {vol.role} | Volunteer Required:{" "}
                            {vol.remaining_count}
                          </p>

                          <div className="row mt-2">
                            {vol.userId.map((user) => (
                              <div
                                key={user._id}
                                className="flex items-center gap-3 p-2 bg-gray-100 rounded-lg"
                              >
                                <img
                                  src={user.profilePic || "/img/user.jpg"}
                                  alt={user.firstName}
                                  className="rounded-full object-cover"
                                   height={70}
                                  width={70}
                                />
                                <div>
                                  <p className="font-medium">
                                    {user.firstName} {user.lastName}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                    {user.mobile}
                                  </p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )} */}

								{Array.isArray(eventDetails?.event_photo_upload) &&
									eventDetails.event_photo_upload.length > 0 && (
										<div className="mb-3">
											<strong>Event Upload Photos:</strong>
											<div className="mt-3 border-b pb-2">
												<div className="row mt-2">
													{eventDetails.event_photo_upload.map((photo, index) => (
														<div key={index} className="flex flex-row gap-2">
															<PostPreview value={photo.url} />

															{/* {photo.type === "video/mp4" ? (
                                  <video
                                    controls
                                    style={{
                                      width: "150px",
                                      maxHeight: "150px",
                                      borderRadius: "10px",
                                      marginLeft: "5px",
                                    }}
                                    src={photo.url}
                                  />
                                ) : (
                                  <img
                                    src={photo.url}
                                    alt="event upload"
                                    style={{
                                      width: "150px",
                                      maxHeight: "150px",
                                      borderRadius: "10px",
                                      objectFit: "cover",
                                      marginLeft: "5px",
                                    }}
                                  />
                                )} */}
														</div>
													))}
												</div>
											</div>
										</div>
									)}

								{/* {eventDetails?.boli_items?.length > 0 && (
                  <div className="mb-3">
                    <strong className="block mb-2">Boli Items:</strong>
                    <div className="row flex flex-col gap-6">
                      {eventDetails.boli_items.map((item, index) => (
                        <div
                          key={index}
                          className="p-3  rounded-lg  bg-white space-y-2"
                        >
                          <p>
                            <strong>Item Name:</strong> {item.item_name}
                          </p>
                          <p>
                            <strong>Amount Required:</strong> ₹
                            {item.amount_required}
                          </p>
                          <p>
                            <strong>Amount Received:</strong> ₹
                            {item.amount_received}
                          </p>

                          {Array.isArray(item.sponsored_by) &&
                          item.sponsored_by.length > 0 ? (
                            <div className="grid grid-cols-5 gap-4 mt-2">
                              {item.sponsored_by.map((sponsor, sIndex) => (
                                <div
                                  key={sIndex}
                                  className="flex flex-col items-center bg-gray-50 p-2 rounded"
                                >
                                  <img
                                    src={
                                      sponsor.userId?.profilePic ||
                                      "/img/user.jpg"
                                    }
                                    alt={sponsor.userId?.firstName || "Sponsor"}
                                    className=" object-cover"
                                    width={50}
                                    height={50}
                                  />
                                  <span className="text-sm text-center mt-1">
                                    {sponsor.userId?.firstName}{" "}
                                    {sponsor.userId?.lastName}
                                  </span>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p className="text-gray-500">No sponsors yet.</p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )} */}

								<div>
									{participants.length > 0 && (
										<>
											{participants.some(p => p.interaction === 'Present') && (
												<>
													<h6 className="font-bold mb-3 text-green-600">Present Users</h6>
													<div className="row mt-2">
														{participants
															.filter(p => p.interaction === 'Present')
															.map(participant => (
																<div
																	key={participant.userId._id}
																	className="flex items-center gap-3 p-2 bg-gray-100 rounded-lg"
																>
																	<PostPreview
																		value={participant?.userId?.profilePic || '/img/user.jpg'}
																	/>
																	<div>
																		<p className="font-medium">
																			{participant.userId.firstName} {participant.userId.lastName}
																		</p>
																		<p className="text-sm text-gray-600">
																			{participant.userId.mobile}
																		</p>
																	</div>
																</div>
															))}
													</div>
												</>
											)}

											{participants.some(p => p.interaction === 'Absent') && (
												<>
													<h6 className="font-bold mb-3 text-red-600 mt-6">Absent Users</h6>
													<div className="row mt-2 ml-3">
														{participants
															.filter(p => p.interaction === 'Absent')
															.map(participant => (
																<div
																	key={participant.userId._id}
																	className="flex items-center gap-3 p-2 bg-gray-100 rounded-lg"
																>
																	<PostPreview
																		value={participant?.userId?.profilePic || '/img/user.jpg'}
																	/>
																	<div>
																		<p className="font-semibold">
																			{participant.userId.firstName} {participant.userId.lastName}
																		</p>
																		<p className="text-sm text-gray-600">
																			{participant.userId.mobile}
																		</p>
																	</div>
																</div>
															))}
													</div>
												</>
											)}
										</>
									)}
								</div>
								<div>
									{participants.length > 0 && (
										<>
											<h6 className="font-bold mb-3 text-green-600">Joinee</h6>
											<div className="row mt-2">
												{participants
													.filter(p => p.status === 'Accepted')
													.map(participant => (
														<>
															<div
																key={participant.userId._id}
																className="flex items-center gap-3 p-2 bg-gray-100 rounded-lg"
															>
																<PostPreview
																	value={participant?.userId?.profilePic || '/img/user.jpg'}
																/>

																{/* <img
                                  src={
                                    participant?.userId?.profilePic ||
                                    "/img/user.jpg"
                                  }
                                  alt={participant?.userId?.firstName}
                                  className="rounded-full object-cover"
                                  height={70}
                                  width={70}
                                /> */}
																<div>
																	<p className="font-medium">
																		{participant.userId.firstName} {participant.userId.lastName}
																	</p>
																	<p className="text-sm text-gray-600">
																		{participant.userId.mobile}
																	</p>
																</div>
															</div>
														</>
													))}
											</div>

											{participants.some(p => p.status === 'Rejected') && (
												<>
													<h6 className="font-bold mb-3 text-red-600 mt-6">
														Rejected Participants
													</h6>
													<div className="row mt-2 ml-3">
														{participants
															.filter(p => p.status === 'Rejected')
															.map(participant => (
																<div
																	key={participant.userId._id}
																	className="flex items-center gap-3 p-2 bg-gray-100 rounded-lg"
																>
																	<PostPreview
																		value={participant?.userId?.profilePic || '/img/user.jpg'}
																	/>

																	{/* <img
                                    src={
                                      participant.userId.profilePic ||
                                      "/img/user.jpg"
                                    }
                                    alt={participant.userId.firstName}
                                    className="rounded-full object-cover"
                                    height={70}
                                    width={70}
                                  /> */}
																	<div>
																		<p className="font-semibold">
																			{participant.userId.firstName} {participant.userId.lastName}
																		</p>
																		<p className="text-sm text-gray-600">
																			{participant.userId.mobile}
																		</p>
																	</div>
																</div>
															))}
													</div>
												</>
											)}
										</>
									)}
								</div>
							</div>

							<div className="modal-footer">
								<button className="btn btn-secondary" onClick={handleCloseEventDetails}>
									Close
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default TableFilter
